import React from 'react'
import { Outlet } from 'react-router-dom';
import Financials from './Financials';
import '../MainBody.css'


function FinancialLayout() {
  return (
    <div className='projects_container'>
      <div className='projects_sidebar'>
        <Financials />
      </div>
      <div className='projects_main'>
        <Outlet />
      </div>
    </div>
  )
}

export default FinancialLayout